module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_fluctuation_03.0bd65dc0.png";